import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    VALIDATE_RESET_LINK: (reset, time) => ({
        url: `forgot-password/validate-link?reset=${reset}&time=${time}`,
        method: "get",
    }),

    // RESET_PASSWORD: {
    //     url: "forgot-password/reset",
    //     method: "post",
    // },

    CHECK_RESET_VALIDITY: (resetCode, time) => ({
        url: `check-validity?reset=${resetCode}&time=${time}`,
        method: "get",
    }),

    RESET_PASSWORD: {
        url: "reset-password",
        method: "post",
    },
    FORGOT_PASSWORD_CHECK: {
        url: "/forgot-password/check",
        method: "post",
    },
};

export const useValidateResetLink = (reset, time) =>
    useApiFetcherSWR(
        reset && time
            ? API_ENDPOINT.VALIDATE_RESET_LINK(reset, time)
            : { url: null, method: "get" }
    );

export const useResetPassword = () =>
    useApiFetcherSWR(API_ENDPOINT.RESET_PASSWORD);

export const useResetPasswordValidity = (resetCode, time) =>
    useApiFetcherSWR(
        resetCode && time
            ? API_ENDPOINT.CHECK_RESET_VALIDITY(resetCode, time).url
            : null
    );

export const useForgotPasswordCheck = () =>
    useApiFetcherSWR(API_ENDPOINT.FORGOT_PASSWORD_CHECK);

